<template>
  <div class="container bg-gray-100 pb-4 pt-5 p-4">
    <router-link type="button" class="hover:underline block text-left" to="/">
      <!-- <a type="button" class="hover:underline" @click="$router.go(-1)"> -->
      <svg
        class="h-8 w-8 fill-current text-blue-900"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="274.835 394.86 54.965 55.15"
      >
        <defs />
        <path
          d="M302.4 395.823c14.752.013 26.694 12.004 26.695 26.805.001 14.592-12.041 26.517-26.753 26.495-14.737-.023-26.754-11.98-26.684-26.551.072-14.873 11.958-26.763 26.742-26.749zm.342 32.534h2.447c3.522 0 7.044.033 10.565-.013 2.327-.03 3.413-1.138 3.479-3.442.039-1.364.033-2.731.003-4.096-.057-2.537-.978-3.536-3.514-3.605-2.801-.076-5.605-.022-8.408-.024-1.471-.001-2.942 0-4.571 0 0-1.899.247-3.457-.079-4.885-.254-1.114-1.01-2.527-1.934-2.949-.783-.357-2.422.2-3.171.899-3.518 3.284-6.88 6.737-10.254 10.171-1.618 1.646-1.652 3.053-.056 4.689 3.413 3.497 6.829 6.997 10.403 10.326.73.68 2.361 1.107 3.203.755.868-.363 1.601-1.754 1.812-2.811.3-1.513.075-3.132.075-5.015z"
        />
      </svg>
      <!-- </a> -->
    </router-link>
    <div class="shadow-2xl bg-white p-4">
      <p class="text-gray-900 text-center text-3xl mb-0">¡Cotiza ahora!</p>
      <!-- Cada ID de cada b-form-radio-group debe ser diferente -->
      <b-form-group class="text-center m-0 p-0">
        <b-form-radio-group
          
          class="m-0"
          id="btn-radios-2"
          v-model="quotationFor"
          :options="optionsQuotationFor"
          buttons
          size="sm"
          button-variant="outline-primary"
          name="radio-btn-stacked"
          @change="setQuotationFor"
        ></b-form-radio-group>
      </b-form-group>
      <div v-if="quotationFor == 'Cotizar para dependiente'">
      <span class="w-full" 
        >Estado Civil del contratante:</span>

      <b-form-group
        class="text-center mt-2"
      >
        <b-form-radio-group
          id="btn-radios-3"
          v-model="maritalStatus"
          :options="optionsMaritalStatus"
          buttons
          button-variant="outline-primary"
          size="sm"
          name="radio-btn-stacked"
        ></b-form-radio-group>
      </b-form-group>

      <b-form-group
        class="text-center -mt-4"
      >
        <b-form-radio-group
          id="btn-radios-4"
          v-model="maritalStatus"
          :options="optionsMaritalStatus2"
          buttons
          button-variant="outline-primary"
          size="sm"
          name="radio-btn-stacked"
        ></b-form-radio-group>
      </b-form-group>
    </div>
      <span
        class="w-full"
        v-if="quotationFor == 'Cotizar para dependiente' && maritalStatus != ''"
        >Parentesco del dependiente:</span
      >

      <b-form-group
        class="text-center mt-2"
        v-if="
          quotationFor == 'Cotizar para dependiente' &&
          maritalStatus == 'Soltero(a)'
        "
      >
        <b-form-radio-group
          id="btn-radios-5"
          v-model="kinship"
          :options="optionsKinshipForSingle"
          buttons
          button-variant="outline-primary"
          size="sm"
          name="radio-btn-stacked"
        ></b-form-radio-group>
      </b-form-group>

      <b-form-group
        class="text-center mt-2"
        v-if="
          quotationFor == 'Cotizar para dependiente' &&
          maritalStatus == 'Casado(a)'
        "
      >
        <b-form-radio-group
          id="btn-radios-6"
          v-model="kinship"
          :options="optionsKinshipForMarried"
          buttons
          button-variant="outline-primary"
          size="sm"
          name="radio-btn-stacked"
        ></b-form-radio-group>
      </b-form-group>

      <b-form-group
        class="text-center mt-2"
        v-if="
          quotationFor == 'Cotizar para dependiente' &&
          maritalStatus == 'Viudo(a)'
        "
      >
        <b-form-radio-group
          id="btn-radios-7"
          v-model="kinship"
          :options="optionsKinshipForWidow"
          buttons
          button-variant="outline-primary"
          size="sm"
          name="radio-btn-stacked"
        ></b-form-radio-group>
      </b-form-group>

      <b-form-group
        class="text-center mt-2"
        v-if="
          quotationFor == 'Cotizar para dependiente' &&
          maritalStatus == 'Divorciado(a)'
        "
      >
        <b-form-radio-group
          id="btn-radios-8"
          v-model="kinship"
          :options="optionsKinshipForDivorced"
          buttons
          button-variant="outline-primary"
          size="sm"
          name="radio-btn-stacked"
        ></b-form-radio-group>
      </b-form-group>

      <b-form-group
        class="text-center mt-2"
        v-if="
          quotationFor == 'Cotizar para dependiente' &&
          maritalStatus == 'Concubinato'
        "
      >
        <b-form-radio-group
          id="btn-radios-9"
          v-model="kinship"
          :options="optionsKinshipForConcubinage"
          buttons
          button-variant="outline-primary"
          size="sm"
          name="radio-btn-stacked"
        ></b-form-radio-group>
      </b-form-group>

      <form
        autocomplete="off"
        @submit.prevent="onSubmit()"
        class="flex flex-wrap"
      >
        <!-- <form @keydown.enter.prevent.self="onSubmit" class="flex flex-wrap"> -->
        <div
          class="md:container lg:container xl:container text-left w-full lg:w-1/2 xl:w-full lg:p-10 xl:p-10 mt-3"
        >
          <div class="w-full">
            <label > Edad </label>
            <input
              id="input_age"
              ref="age"
              type="number"
              required
              v-model="age"
              min="1"
              max="69"
              @keydown.enter.prevent.self
              class="w-full shadow-md appearance-none border rounded py-2 px-3 text-grey-darker"
            />
          </div>
        </div>

        <div
          class="md:container lg:container text-left xl:container w-full lg:w-1/2 xl:w-full lg:p-10 xl:p-10 mt-2 lg:mt-5 flex flex-wrap"
        >
          <div class="w-full">
            <label> Sección: </label>
            <v-select
              id="select_section"
              :clearable="false"
              :searchable="false"
              v-model="selectedSection"
              class="w-full shadow-md appearance-none border rounded text-grey-darker"
              :options="selectSectionOptions"
              :placeholder="'Seleccione una sección'"
              @option:selecting="changePaymentMethod(selectedSection)"

            >
              <template v-slot:no-options>
                <template> No hay resultados. </template>
              </template>
            </v-select>
            <span v-if="errorSection" class="text-red-600 text-xs"
              >Seleccione una sección</span
            >
          </div>
        </div>

        <div
          class="md:container lg:container xl:container w-full lg:w-1/2 xl:w-full lg:p-10 xl:p-10 mt-2 lg:mt-5 flex flex-wrap"
        >
          <label> Tipo de Pago: </label>
          <v-select
            id="select_payment_type"
            :clearable="false"
            :searchable="false"
            v-model="selectedPayment"
            class="appearance-none rounded text-grey-darker w-full shadow-md"
            :options="selectPayment"
            :placeholder="'Seleccione un tipo de pago'"
            :required="selectedPayment"
          >
            <template v-slot:no-options>
              <template> No hay resultados. </template>
            </template>
          </v-select>
          <span v-if="errorPayment" class="text-red-600 text-xs"
            >Seleccione un tipo de pago</span
          >
        </div>
        
        <div class="w-full flex justify-center p-2 text-center lg:mt-5 mb-2">
        
          <button
            id="button_quote_coverage"
            class="w-full md:w-2/5 mt-3 flex justify-center xl:w-2/6 bg-orange-600 hover:bg-orange-700 text-lg md:text-xl lg:text-xl lx:text-xl text-white font-bold py-2 rounded"
          >
           <loading
                 :height="15"
                 color="#fff"
                 class="static"
                 :active="isLoading"
                 loader="dots"
                 :can-cancel="true"
                 :is-full-page="false"
                />
            <p  class="flex items-center text-center m-0" v-if="!isLoading">
              Cotizar Coberturas <mdicon name="chevron-right" />
            </p>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import "@/assets/css/radioButton.css";
import axios from "axios";
import Swal from "sweetalert2";
import Loading from 'vue-loading-overlay';
import emptyPolicy from "../assets/EmptyPolicy.json";

import { ref, onMounted } from 'vue';
export default {
  name: "Quotation",
  components: {
    Loading
  },
  setup(){
    const buttonTag = ref(null)
    onMounted(()=>{
      console.log("buttonTag", buttonTag.value)
    })
    return {
      buttonTag
    }
  },
  data() {
    return {
      isLoading: false,
      associateData: "",
      dataPolicyByBusiness: {},
      policy: null,
      quotationFor: "Cotizar para mí",
      age: null,
      name: null,
      errorSection: false,
      errorPayment: false,
      sections: [],
      selectedSection: [],
      maritalStatus: "",
      kinship: "",
      kinship2: "",
      selectedPayment: [],
      api_lineamagisterialproducts:
        process.env.VUE_APP_APILINEAMAGISTERIALPRODUCTS,
      api_CABSACORE: process.env.VUE_APP_APICABSACORE,
      api_LMCORE: process.env.VUE_APP_LMCORE,
      optionsQuotationFor: [
        { text: "Cotizar para mí", value: "Cotizar para mí" },
        { text: "Cotizar para dependiente", value: "Cotizar para dependiente" },
      ],
      optionsMaritalStatus: [
        { text: "Soltero(a)", value: "Soltero(a)" },
        { text: "Casado(a)", value: "Casado(a)" },
        { text: "Viudo(a)", value: "Viudo(a)" },
      ],
      optionsMaritalStatus2: [
        { text: "Divorciado(a)", value: "Divorciado(a)" },
        { text: "Concubinato", value: "Concubinato" },
      ],
      optionsKinshipForSingle: [
        { text: "Padres", value: "Padres" },
        { text: "Hijo(a)", value: "Hijo(a)" },
      ],
      optionsKinshipForMarried: [
        { text: "Cónyugue", value: "Cónyugue" },
        { text: "Hijo(a)", value: "Hijo(a)" },
      ],
      optionsKinshipForDivorced: [{ text: "Hijo(a)", value: "Hijo(a)" }],
      optionsKinshipForWidow: [{ text: "Hijos", value: "Hijo(a)" }],
      optionsKinshipForConcubinage: [
        { text: "Cónyugue", value: "Cónyugue" },
        { text: "Hijo(a)", value: "Hijo(a)" },
      ],
    };
  },
  created() {
    this.getSections();
  },
 mounted(){
  this.$refs.age?.focus();
  //localStorage.removeItem("policy");
  localStorage.clear()
  localStorage.setItem("policy", JSON.stringify(emptyPolicy));
  
  this.verifyExistItemStorage();
  /* if(localStorage.getItem("kinship")){
    console.log("kinship: ",localStorage.getItem("kinship"));
    this.maritalStatus = localStorage.getItem("maritalStatus");
    this.kinship = localStorage.getItem("kinship")
    if(this.kinship === "Titular"){
      this.quotationFor = "Cotizar para mí"
    }else{
      this.quotationFor = "Cotizar para dependiente"
    }
  } */
 },
  methods: {
    changePaymentMethod(selectedSection){
      this.selectedPayment.label = "Seleccione un tipo de pago";
      this.selectedPayment.value = "Seleccione un tipo de pago";
      console.log("val: ", selectedSection);
    },
    verifyExistItemStorage(){
      if(localStorage.getItem("ap_label")){
        localStorage.removeItem("ap_label");
        localStorage.removeItem("ap_value");
      }
      if(localStorage.getItem("ic_label")){
        localStorage.removeItem("ic_label");
        localStorage.removeItem("ic_value");
      }
      if(localStorage.getItem("rh_label")){
        localStorage.removeItem("rh_label");
        localStorage.removeItem("rh_value");
      }
      if(localStorage.getItem("ie_label")){
        localStorage.removeItem("ie_label");
        localStorage.removeItem("ie_value");
      }
      if(localStorage.getItem("pi_label")){
        localStorage.removeItem("pi_label");
        localStorage.removeItem("pi_value");
      }
    },
    fromLocalStorage(){
        const age = localStorage.getItem("age") ?? null;
        const section = Number(localStorage.getItem("section")) ?? null;
        const sectionDesc = localStorage.getItem("sectionDescription") ?? 'Seleccione una sección';
        const payment = localStorage.getItem("payment_type") ?? 'Seleccione un tipo de pago';
        this.age = age;
        this.selectedSection = {
          label: sectionDesc,
          value: section
        };
        this.selectedPayment = {
          label: payment,
          value: payment
        }
      console.log("onChange: ", this.selectedSection)

    },
    setQuotationFor(){
      if(this.quotationFor === 'Cotizar para mí'){
        this.maritalStatus = '';
        this.kinship = '';
      }else{
        this.maritalStatus = localStorage.getItem("maritalStatus");
        this.kinship = localStorage.getItem("kinship");
      }
    },
    doAjax() {
                this.isLoading = true;
                // simulate AJAX
                setTimeout(() => {
                    this.isLoading = false
                }, 1000)
            },
    getSections() {
      axios
        .get(this.api_lineamagisterialproducts + "/business/get_all", {})
        .then((response) => {
          this.sections = response.data.result;
          this.fromLocalStorage()
        });
    },
    onSubmit() {
      this.errorPayment = false;
      this.errorSection = false;
      if (this.selectedSection.value > 0) {
        console.log("selectedPayment; ", this.selectedPayment);
        if (this.selectedPayment.value != "Seleccione un tipo de pago") {
          var dataInfo = "";
          var sectionSelected = this.selectedSection.label;
          var quotationFor =
            this.quotationFor == "Cotizar para dependiente"
              ? "Dependiente"
              : "Mí";

          if (this.quotationFor == "Cotizar para dependiente") {
            if (
              this.maritalStatus == undefined ||
              this.maritalStatus == null ||
              this.maritalStatus == ""
            ) {
              Swal.fire(
                "Estado civil no admitido",
                "Seleccione el estado civil del contratante.",
                "info"
              );
              return;
            }

            if (this.kinship == undefined || this.kinship == null || this.kinship == "") {
              Swal.fire(
                "Parentesco no admitido",
                "Seleccione el parentesco del dependiente.",
                "info"
              );
              return;
            }

            if (this.age > 25 && this.kinship == "Hijo(a)") {
              Swal.fire(
                "Edad no admitida",
                "La edad del dependediente debe ser menor o igual a 25 años.",
                "info"
              );
              return;
            }else if (this.kinship == "Padres" && this.age < 11) {
              Swal.fire(
                "Edad no admitida",
                "La edad del dependediente debe ser mayor o igual a 11 años.",
                "info"
              );
              return;
            } else {
              dataInfo =
                '<table style="width:100%">' +
                "  <tr>" +
                '    <th style="text-align: center;">Cotización para</th>' +
                '    <th style="text-align: center;">Parentesco</th>' +
                '    <th style="text-align: center;">Edad</th>' +
                '    <th style="text-align: center;">Sección</th>' +
                "  </tr>" +
                "  <tr>" +
                "    <td>" +
                quotationFor +
                "</td>" +
                "    <td>" +
                this.kinship +
                "</td>" +
                "    <td>" +
                this.age +
                "</td>" +
                "    <td>" +
                sectionSelected +
                "</td>" +
                "  </tr>" +
                "</table>";
            }
          } else {
            //titular(Mí)
            if (this.age < 18) {
              Swal.fire(
                "Edad no admitida",
                "La edad del titular debe ser igual o mayor a 18 años.",
                "info"
              );
              return;
            }
            dataInfo =
              '<table style="width:100%">' +
              "  <tr>" +
              '    <th style="text-align: center;">Cotización para</th>' +
              '    <th style="text-align: center;">Edad</th>' +
              '    <th style="text-align: center;">Sección</th>' +
              "  </tr>" +
              "  <tr>" +
              "    <td>" +
              quotationFor +
              "</td>" +
              "    <td>" +
              this.age +
              "</td>" +
              "    <td>" +
              sectionSelected +
              "</td>" +
              "  </tr>" +
              "</table>";
          }

          Swal.fire({
            title: "Confirmación de los datos",
            html: dataInfo,
            icon: "info",
            showCancelButton: true,
            confirmButtonColor: "#06623b",
            cancelButtonColor: "#d33",
            confirmButtonText: "<button id='button_confirm'> Confirmar </button>",
            cancelButtonText: "<button id='button_cancel'>Cancelar </button>",
            reverseButtons: true,
          }).then((result) => {
            if (result.value) {
              localStorage.setItem("age", this.age);
              localStorage.setItem("section", this.selectedSection.value);
              localStorage.setItem(
                "sectionDescription",
                this.selectedSection.label
              );
              localStorage.setItem(
                "kinship",
                this.kinship ? this.kinship : "Titular"
              );
              localStorage.setItem("maritalStatus", this.maritalStatus);
              localStorage.setItem("payment_type", this.selectedPayment.value);
              if (this.getPolicyFromLocalStorage()) {
                this.addPolicyByBusiness();
              } else {
                Swal.fire(
                  "Error",
                  "Se presentó un error, no fue posible cargar los datos. Favor de contactar a sistemas.",
                  "error"
                );
                this.$router.push({ name: "home" });
              }
            }
          });
        } else {
          this.errorPayment = true;
        }
      } else {
        this.errorSection = true;
      }
    },
    getPolicyFromLocalStorage() {
      console.log(this.policy)
      this.policy = JSON.parse(localStorage.getItem("policy"));
      console.log("this policy", this.policy)
      return !!this.policy;
    },
    async addPolicyByBusiness() {
      this.isLoading = true;
      if (this.selectedSection.label == null) {
        Swal.fire(
          "Error",
          "Se presentó un error, no fue posible encontrar la sección. Favor de contactar a sistemas.",
          "error"
        );
        return;
      }

      if (this.selectedPayment.label == null){
        Swal.fire(
          "Error",
          "Se presentó un error, no fue posible encontrar el tipo de pago. Favor de contactar a sistemas.",
          "error"
        );
        return;
      }

      let paymentType = this.selectedPayment.value.replaceAll("%","")
      let nameSection = this.selectedSection.label.replaceAll("Seccion 24","Queretaro")

      await axios.get(this.api_LMCORE +"/get_global_insurance_policy", {
        params: {
          name_section: nameSection,
          payment_type: paymentType
        },
      }).then((response) => {
        this.dataPolicyByBusiness = response.data.poliza;
        this.policy.policy_number = this.dataPolicyByBusiness.poliza;
        this.policy.policy_request_id = "688";
        this.policy.start_validity = this.dataPolicyByBusiness.inicio_de_vigencia;
        this.policy.final_validity = this.dataPolicyByBusiness.fin_de_vigencia;
        localStorage.setItem("policy", JSON.stringify(this.policy));
        this.addAssociateModel();
      }).catch((error) => {
        console.log(
          "Se presentó un error al agregar la solicitud en addPolicyByBusiness: ",
          error
        );
        Swal.fire(
          "Error",
          "Se presentó un error, al agregar la solicitud. Favor de contactar a sistemas.",
          "error"
        );
        this.$router.push({ name: "home" });
      });
      
    },
    async addAssociateModel() {
      let reference = sessionStorage.getItem("reference");
      console.log("Reference", reference)
      let params = {};
      let request = "";
      if (reference != null) {
        params = { reference: reference };
        request = "get_associate_by_reference";
      } else {
        params = {
          business: "LM",
          section: this.selectedSection.label,
          process_type: "REFERENCIA PARA VENTA SIN ASESOR",
        };
        request = "get_default_associate";
      }
      await axios
        .get(this.api_lineamagisterialproducts + "/" + request, {
          params: params,
        })
        .then((response) => {
          this.associateData = response.data.asociado;
          this.policy.associate_data.code_reference = reference;
          this.policy.associate_data.name =
            this.associateData.first_name +
            " " +
            this.associateData.second_name +
            " " +
            this.associateData.paternal_lastname +
            " " +
            this.associateData.maternal_lastname;
          this.policy.associate_data.employee_number = this.associateData.associated_number;
          this.policy.associate_data.id = this.associateData.id;
          localStorage.setItem("policy", JSON.stringify(this.policy));
          this.$router.push({ name: "benefitByReference" });
        })
        .catch((error) => {
          console.log(
            "Se presentó un error al agregar la referencia en get_associate_by_reference: ",
            error
          );
          Swal.fire(
            "Error",
            "Se presentó un error al agregar la referencia. Favor de contactar a sistemas.",
            "error"
          );
          this.$router.push({ name: "home" });
        })
        .finally(() => (this.isLoading = false));
    },
  },
  computed: {
    selectPayment() {
      if (this.selectedSection?.label == undefined || this.selectedSection?.label == "Seleccione una sección"){
        return [{ label: "", value: "" }];
      }
      if (this.selectedSection?.label == "Seccion 2") {
        return [
          { label: "NÓMINA ISEP", value: "NÓMINA ISEP" },
          { label: "NÓMINA 22%", value: "NÓMINA 22%" },
        ];
      } else {
        return [{ label: "NÓMINA", value: "NÓMINA" }];
      }
    },
    selectSectionOptions() {
      let array = [];
      this.sections.forEach(function (element) {
        if (element.section != "Seccion 17") {
          array.push({
            label: element.section,
            value: element.id,
          });
        }
      });
      return array;
    }
  },
};
</script>

<style scoped>

</style>